// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../index.scss";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*SCSS mixins for devices*/
:root {
  --tile-bg: #ffffff;
  --tile-fg: #000000;
  --tile-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  --background-blur: 7.76px;
}

[data-theme=light] {
  --tile-bg: #aaaaaa;
  --tile-fg: #000000;
  --tile-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  --tile-bg-blur: rgba(0, 0, 0, 0.10);
}

[data-theme=dark] {
  --tile-bg: #666666;
  --tile-fg: #ffffff;
  --tile-shadow: 0 0 5px rgba(255, 255, 255, 0.3);
  --tile-bg-blur: rgba(0, 0, 0, 0.29);
}

.debug {
  border: 1px solid red;
  background-color: aqua;
}

.Tile, .BlankTile {
  background-color: var(--tile-bg);
  opacity: 1;
  border-radius: 20px;
  height: 100px;
  margin: 5px;
  width: 100px;
  transition: transform var(--transition-time) ease;
  z-index: 1;
  backdrop-filter: var(--background-blur);
  background: var(--tile-bg-blur);
}

.BlankTile {
  background: none;
  box-shadow: none;
  color: var(--color-fg);
  user-select: none;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.BlankTile p {
  display: block;
  text-align: center;
  width: 80%;
}
@media (max-width: 767px) {
  .BlankTile p {
    font-size: 1rem;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .BlankTile p {
    font-size: 1.1rem;
  }
}
@media (min-width: 1025px) and (max-width: 1439px) {
  .BlankTile p {
    font-size: 1.25rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/_styles.scss","webpack://./src/components/Tile.scss","webpack://./src/components/BlankTile.scss"],"names":[],"mappings":"AAAA,0BAAA;ACEA;EACI,kBAAA;EACA,kBAAA;EACA,yCAAA;EACA,yBAAA;ACCJ;;ADEA;EACI,kBAAA;EACA,kBAAA;EACA,yCAAA;EACA,mCAAA;ACCJ;;ADEA;EACI,kBAAA;EACA,kBAAA;EACA,+CAAA;EACA,mCAAA;ACCJ;;ADEA;EACI,qBAAA;EACA,sBAAA;ACCJ;;ADEA;EACI,gCAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,iDAAA;EACA,UAAA;EACA,uCAAA;EACA,+BAAA;ACCJ;;AApCA;EAEI,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAsCJ;AApCI;EACI,cAAA;EACA,kBAAA;EACA,UAAA;AAsCR;AFnDE;EEUE;IAMQ,eAAA;EAuCV;AACF;AFjDE;EEGE;IAUQ,iBAAA;EAwCV;AACF;AF/CE;EEJE;IAcQ,kBAAA;EAyCV;AACF","sourcesContent":["/*SCSS mixins for devices*/\n\n$mobile-max-width: 767px;\n\n@mixin mobile {\n  @media (max-width: $mobile-max-width) {\n    @content;\n  }\n}\n\n// Tablet screens (768px to 1024px)\n@mixin tablet {\n  @media (min-width: 768px) and (max-width: 1024px) {\n    @content;\n  }\n}\n\n// Desktop screens (1025px to 1439px)\n@mixin desktop {\n  @media (min-width: 1025px) and (max-width: 1439px) {\n    @content;\n  }\n}\n\n// Big monitor screens (1440px and up)\n@mixin big-monitor {\n  @media (min-width: 1440px) {\n    @content;\n  }\n}","@import url('../index.scss');\n\n:root { \n    --tile-bg: #ffffff;\n    --tile-fg: #000000;\n    --tile-shadow: 0 0 5px rgba(0, 0, 0, 0.3);\n    --background-blur: 7.76px;\n}\n\n[data-theme=\"light\"] {\n    --tile-bg: #aaaaaa;\n    --tile-fg: #000000;\n    --tile-shadow: 0 0 5px rgba(0, 0, 0, 0.3);\n    --tile-bg-blur: rgba(0, 0, 0, 0.10);\n}  \n\n[data-theme=\"dark\"] {\n    --tile-bg: #666666;\n    --tile-fg: #ffffff;\n    --tile-shadow: 0 0 5px rgba(255, 255, 255, 0.3);\n    --tile-bg-blur: rgba(0, 0, 0, 0.29);\n}  \n\n.debug {\n    border: 1px solid red;\n    background-color: aqua;\n}\n\n.Tile {\n    background-color: var(--tile-bg);\n    opacity: 1;\n    border-radius: 20px;\n    height: 100px;\n    margin: 5px;\n    width: 100px;\n    transition: transform var(--transition-time) ease;\n    z-index: 1;\n    backdrop-filter: var(--background-blur);\n    background: var(--tile-bg-blur);\n}","@use '../styles';\n@use \"Tile.scss\";\n\n.BlankTile {\n    @extend .Tile;\n    background: none;\n    box-shadow: none;\n    color: var(--color-fg);\n    user-select: none;\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    p {\n        display: block;\n        text-align: center;\n        width: 80%;\n\n        @include styles.mobile {\n            font-size: 1rem;\n        }\n\n        @include styles.tablet {\n            font-size: 1.1rem;\n        }\n\n        @include styles.desktop {\n            font-size: 1.25rem;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
